import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const EditSecGroup = createAction(
  '[Security Groups: Edit Group]: Edit Security Group',
  props<{ row: any }>(),
);

export const SecGroupNameChanged = createAction(
  '[Security Groups: Edit Group]: Group Name Changed',
  props<{ groupName: string }>(),
);

export const SecGroupDescriptionChanged = createAction(
  '[Security Groups: Edit Group]: Group Description Changed',
  props<{ groupDescription: string }>(),
);

export const PolicyInDocumentChanged = createAction(
  '[Security Groups: Edit Group]: Policy In Document Changed',
  props<{ policy: string }>(),
);

export const UserInGroupChanged = createAction(
  '[Security Groups: Edit Group]: User In Group Changed',
  props<{ user: string }>(),
);

export const RemovePolicyDoc = createAction(
  '[Security Groups: Edit Group]: Policy Document Removed',
  props<{ policyDoc: string }>(),
);

export const RemoveUser = createAction(
  '[Security Groups: Edit Group]: User Removed',
  props<{ user: string }>(),
);

export const PoliciesSearchFilterChanged = createAction(
  '[Security Groups: Edit Group]: Policies Search Filter Changed',
  props<{ searchFilterPolicies: string }>(),
);

export const UsersSearchFilterChanged = createAction(
  '[Security Groups: Edit Group]: Users Search Filter Changed',
  props<{ searchFilterUsers: string }>(),
);

export const EditUser = createAction(
  '[Security Groups: Edit Group]: Edit User',
  props<{ user: any }>(),
);

export const CloseEditUserDialog = createAction(
  '[Security Groups: Edit Group]: Close Edit User Dialog',
);

export const UserSubmitted = createAction('[Security Groups: Edit Group]: User Submitted');

export const SaveSecurityGroup = createAction('[Security Groups: Edit Group]: Save Security Group');

export const SaveSecurityGroupSuccess = createAction(
  '[Security Groups: Edit Group]: Save Security Group Success',
  props<{ res: any }>(),
);

export const SaveSecurityGroupFailed = createAction(
  '[Security Groups: Edit Group]: Save Security Group Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CreateSecurityGroup = createAction(
  '[Security Groups: Edit Group]: Create Security Group',
);
